import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react';

import useDocumentClick from '~hooks/useDocumentClick';

import { OptionsContainerAlign } from '..';
import * as S from './style';

export interface OptionsContainerProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  align?: OptionsContainerAlign;
}

export default function OptionsContainer({
  open,
  setOpen,
  children,
  align,
}: PropsWithChildren<OptionsContainerProps>) {
  useDocumentClick(() => setOpen(false));

  if (!open) {
    return null;
  }

  return (
    <S.Wrapper align={align} tabIndex={0}>
      {children}
    </S.Wrapper>
  );
}
